import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Gurus.scss';

const gurus = [
  { id: 1, name: 'Adi Shankaracharya', img: 'https://www.amritapuri.org/images/2000/04/shankara-disciples.jpg', description: 'A philosopher and theologian who consolidated the doctrine of Advaita Vedanta.' },
  { id: 2, name: 'Ramanujacharya', img: 'https://hindupad.com/wp-content/uploads/2013/05/Sri-Ramanujacharya.jpg', description: 'A theologian and philosopher, known for his theory of Vishishtadvaita (qualified non-dualism).' },
  { id: 3, name: 'Madhvacharya', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT8vxxG3c4mP2ntQBqDNWlpIe9EM96xrNluA&s', description: 'A philosopher who founded the Dvaita (dualism) school of Vedanta.' },
  { id: 4, name: 'Swami Vivekananda', img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Swami_Vivekananda_1893_Scanned_Image.jpg/1200px-Swami_Vivekananda_1893_Scanned_Image.jpg', description: 'A spiritual leader and disciple of Ramakrishna Paramahamsa who brought Hindu philosophy to the West.' },
  { id: 5, name: 'Ramakrishna Paramahamsa', img: 'https://im.indiatimes.in/content/2021/Feb/1_602e363815b93.jpg?w=1200&h=900&cc=1&webp=1&q=75', description: 'A 19th-century mystic and spiritual leader who emphasized the unity of all religions.' },
  { id: 6, name: 'Sai Baba of Shirdi', img: 'https://www.tallengestore.com/cdn/shop/products/ShirdiSaiBaba-SpiritualPaintingPoster.jpg?v=1688682538', description: 'A revered saint known for his teachings that blended Hinduism and Islam.' },
  { id: 7, name: 'Sant Kabir', img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThx5KBSLjRJ1gO9oUcVpsSAzk1XcmWxmL8sA&s', description: 'A 15th-century poet-saint known for his writings that criticized religious orthodoxy.' },
  { id: 8, name: 'Tulsidas', img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Tulsidas_composing_his_famous_Avadhi_Ramcharitmanas.jpg/640px-Tulsidas_composing_his_famous_Avadhi_Ramcharitmanas.jpg', description: 'A Hindu poet-saint, reformer, and philosopher renowned for his writings on Lord Rama.' },
  { id: 9, name: 'Sri Yukteswar', img: 'https://i0.wp.com/hindupad.com/wp-content/uploads/Swami-Sri-Yukteswar-Giri.jpg?fit=400%2C500&ssl=1', description: 'A spiritual teacher and the guru of Paramahansa Yogananda, known for his work on astrology and spirituality.' },
  { id: 10, name: 'Paramahansa Yogananda', img: 'https://cdndailyexcelsior.b-cdn.net/wp-content/uploads/2025/01/per.jpg', description: 'A yogi and guru who introduced millions to the teachings of meditation and Kriya Yoga.' },
];

const Gurus = () => {
  const [selectedGuru, setSelectedGuru] = useState(null);

  const openPopup = (guru) => {
    setSelectedGuru(guru);
  };

  const closePopup = () => {
    setSelectedGuru(null);
  };

  return (
    <div className="gurus-container">
      <InnerNav />
      <div className="gurus-content">
        <Zodiac />

        <div className="festival-header">
          <h4>Revered Gurus & Saints in Hinduism</h4>
        </div>

        <div className="festival-grid">
          {gurus.map((guru) => (
            <div className="festival-card" key={guru.id} onClick={() => openPopup(guru)}>
              <img src={guru.img} alt={guru.name} />
              <p>{guru.name}</p>
            </div>
          ))}
        </div>

        {selectedGuru && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>&times;</button>
              <h3>{selectedGuru.name}</h3>
              <img
              src={selectedGuru.img}
                alt={selectedGuru.name}
              />
              <p>{selectedGuru.description}</p>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Gurus;
